<template>
    <div>
        <form>
            <div class="row">
                <div class="col-md-9">
                    <div class="mb-3">
                        <label class="form-label">Nombre</label>
                        <input class="form-control" type="text" v-model="form.name" v-bind:class="formSubmitted ? errors.name ? 'is-invalid' : 'is-valid' : ''" placeholder="" @input="form.name = form.name.toUpperCase()">
                        <div class="invalid-feedback" v-if="errors.name">{{ errors.name }}</div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="mb-3">
                        <label class="form-label">Fecha de Nacimiento</label>
                        <Datepicker class="datepicker-here form-control digits dp1" v-model="form.birthdate" :enable-time-picker="false" :locale="'es-MX'" :format-locale="es" format="dd/MM/yyyy"></Datepicker>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-9">
                    <div class="mb-3">
                        <label class="form-label">Dirección</label>
                        <input class="form-control" placeholder="" v-model="form.address" @input="form.address = form.address.toUpperCase()">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="mb-3">
                        <label class="form-label">Código Postal</label>
                        <input class="form-control" placeholder="" v-model="form.zipcode">    
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="mb-3">
                        <label class="form-label">Correo Electrónico</label>
                        <input class="form-control" placeholder="" v-model="form.email" @input="form.email = form.email.toLowerCase()">
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="mb-3">
                        <label class="form-label">Teléfono (Whatsapp)</label>
                        <input class="form-control" placeholder="" v-model="form.phone">    
                    </div>
                </div>
            </div>
            <br />
            <div class="row">
                <div class="col-md-6">
                    <div class="mb-3"><span style="font-size: 14px; font-weight: bold;">Contacto de Emergencia</span></div>
                </div>
            </div>
            
            <div class="row">
                <div class="col-md-6">
                    <div class="mb-3">
                        <label class="form-label">Nombre</label>
                        <input class="form-control" placeholder="" v-model="form.contact_name" @input="form.contact_name = form.contact_name.toUpperCase()">
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="mb-3">
                        <label class="form-label">Teléfono</label>
                        <input class="form-control" placeholder="" v-model="form.contact_phone">    
                    </div>
                </div>
            </div>
            <br />
            <div class="row">
                <div class="col-md-6">
                    <div class="mb-3"><span style="font-size: 14px; font-weight: bold;">Operación de la App</span></div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="mb-3">
                        <label class="form-label">Usuario / Colaborador</label>
                        <select class="form-select" v-model="form.employee_collaborator_id">
                            <option v-for="(collaborator, index) in collaborators" :key="index" :value="collaborator.id">{{ collaborator.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="mb-3">
                        <label class="form-label">Jefe Inmediato</label>
                        <select class="form-select" v-model="form.employee_boss_id">
                            <option v-for="(boss, index) in bosses" :key="index" :value="boss.id">{{ boss.name }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>

import validations from "@/mixins/validations/employeeValidations";
import modalCleanupMixin from '@/mixins/commen/modalCleanupMixin';

import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { es } from 'date-fns/locale'

import ws from '@/services/employees'

export default {
    name: 'employee_general_tab',
    mixins: [validations, modalCleanupMixin],
    components: {
        Datepicker
    },
    data(){
        return{
            employee: null,
            collaborators: [],
            bosses: []
        }
    },
    methods: {
        async loadEmployee(employee){
            this.employee = employee;

            let response = await ws.getCollaborators(); 

            if(response.type == "success"){
                this.collaborators = response.data;
            }

            let response2 = await ws.getBosses(); 

            if(response2.type == "success"){
                this.bosses = response2.data;
            }

            this.setForm(this.employee);
        },
        async updateGeneralEmployee(form) {
            let response = await ws.updateEmployee(form);

            if(response.type == "success"){
                this.$toast.success(response.message);

                this.$emit('refresh', response.data);
            }
            else{
                this.$toast.error(response.message);
            }
        },
        validations(){
            this.updateEmployeeGeneralValidation();
        }
    }
}
</script>
<style>
    .dp1{
        input {
            height: 24px;
        }
    }
</style>